// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"173":"58d5cf4a","284":"2efe33aa","326":"2f455129","416":"3faa697d","679":"96830ea5","717":"4f11cb8c","787":"ecdfa5f5","878":"8141f7cd"}[chunkId] + ".chunk.js";
};